<script setup lang="ts">
    import { Ref, computed, onMounted, ref } from 'vue';

    // Props
    const props = withDefaults(defineProps<{
        id: string
        onInput?: Function
        onBlur?: Function
        onChange?: Function
        inputLabel?: string
        placeholder?: string
        type: string
        errors: string | null
        value: string
        classes?: any[]
        inputLabelClasses?: any[]
        disabled?: boolean
        maxlength?: string,
        textAlign?: string
        addInputColor?: boolean
        userSizedClass?: boolean
    }>(), {
        type: 'text',
        errors: null,
        disabled: false,
        textAlign: 'start',
        addInputColor: false,
        userSizedClass: false,
    })

    // Emits
    const emit = defineEmits(['update:value'])

    // Refs
    const phoneinput: Ref<any> = ref(null)
    const phone = ref(props.value)
    let inputLabelClasses: Ref<any> = ref(props.inputLabelClasses || [])

    onMounted(() => {
        if(props.userSizedClass) {
            inputLabelClasses.value.push('sized-text')
        } 
    })

    // Computed variables
    const formatedPhoneNumber = computed(() => {
        if (phone.value) {
            const phoneNumber = phone.value
            const phoneNumberRegex = /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/
            const formatedPhoneNumber = phoneNumber.replace(phoneNumberRegex, '$1 $2 $3 $4 $5')
            return formatedPhoneNumber.trim()
        } else {
            return null
        }
        
    })

    // Functions
    const onInput = (event: any) => {
        phone.value = event.target.value.replace(/[^0-9]/g, '')

        if (phoneinput.value !== null) {
            phoneinput.value.value = phone.value
            emit('update:value', phone.value)
        }
    }
</script>

<template>
    <label :class="inputLabelClasses"
        v-if="inputLabel" 
        class="form-label" 
        :for="id">{{ inputLabel }}</label>
    <input
        ref="phoneinput"
        :type="type" 
        :id="id"
        :maxlength="maxlength"
        :value="formatedPhoneNumber"
        :disabled="disabled"
        @input="onInput"
        class="form-control mb-0" 
        :class="{ 
            'border-danger': errors,
            'text-center': textAlign == 'center',
            'text-start': textAlign == 'start',
            'input-color': addInputColor
        }"
        :placeholder="placeholder"/>
    <p class="mb-0 text-danger" v-if="errors">{{ errors }}</p>
</template>

<style scoped>
    @import url('@/assets/css/bootstrap-extended2.css');
    @import url('@/assets/css/bootstrap-extended.css');

    .form-check-input:checked {
        background-color: #FEB23C;
        border-color: #FEB23C;
    }
     .form-control{
        height: 50px !important;
        font-size: 16px;
    }
    .form-control:focus {
        border-color: #FEB23C;
        box-shadow: 0 0 0 0.02rem #FEB23C;
        /* padding-left: 1.5rem; */
    }

    .input-label-color {
        color: rgba(255, 255, 255, 0.76) !important;
    }

    .input-color {
        color: #6e6b7b !important;
    }
</style>